import { InquiryType } from '../type/Inquiry.type';

export const inquiryInitialize: InquiryType = {
    detail: null,
}
